'use client';

import { FC, useRef, useState } from 'react';
import * as prismicH from '@prismicio/helpers';
import { BlogPostDocument } from '@/types';
import {
  BannerFeaturePosts,
  Breadcrumb,
  Button,
  CollectionPosts,
  Container,
  IconSvg,
  Input,
} from '@/components';
import { BREADCRUMB_ITEMS } from './constants';
import { debounce } from 'lodash';
import { IBlogPageContent } from './page';

const NUMBER_POSTS_DISPLAY_PER_PAGE: number = 16;

const Blog: FC<IBlog> = ({ pageContent, featuredPosts, hasPagination }) => {
  const {
    articleList: paginatedArticleList,
    title,
    filterOptions,
    blogProps,
  } = pageContent;
  const searchBoxRef = useRef<HTMLInputElement>(null);
  const [searchTerm, setSearchTerm] = useState(null);

  const description = prismicH.asText(blogProps?.description);

  const numberPostPerPage =
    blogProps?.numberPostPerPage || NUMBER_POSTS_DISPLAY_PER_PAGE;

  return (
    <Container as="section" className="blog">
      <Breadcrumb className="container" items={BREADCRUMB_ITEMS}>
        {title}
      </Breadcrumb>
      <div className="blog__header">
        <h1
          dangerouslySetInnerHTML={{
            __html: blogProps?.title,
          }}
          style={{
            color: blogProps?.pageTitleColor!,
          }}
        />
        <div className="blog__search_box">
          <Input
            autoComplete="off"
            className="blog__search_box__input"
            isSmall
            name={'searchBox'}
            onChange={debounce(e => {
              setSearchTerm(e?.target?.value);
            }, 300)}
            placeholder="Search"
            ref={searchBoxRef}
            type="search"
          />
          <Button
            className="blog__search_box__button"
            color="primary"
            onClick={() => {
              setSearchTerm(searchTerm);
            }}
          >
            <IconSvg name="search" />
          </Button>
        </div>
      </div>
      {description && (
        <p
          className="blog__description"
          dangerouslySetInnerHTML={{
            __html: description,
          }}
          style={{
            color: blogProps?.textColor!,
          }}
        />
      )}
      <BannerFeaturePosts articleList={featuredPosts} props={blogProps} />
      <CollectionPosts
        articlesList={paginatedArticleList}
        filterOptions={filterOptions}
        hasPagination={hasPagination}
        numberPostPerPage={numberPostPerPage}
        props={blogProps}
        searchTerm={searchTerm!}
      />
    </Container>
  );
};

export default Blog;

interface IBlog {
  pageContent: IBlogPageContent;
  featuredPosts: BlogPostDocument<string>[];
  hasPagination: boolean;
}
